import React , {useEffect} from 'react'
import { useDispatch } from 'react-redux';
import { addUTMData } from '../Utils/DataSlice';
function useGetUTMData() {
    const baseURL = process.env.REACT_APP_BASE_URL;
  const dispatch = useDispatch();
    const getUTMdata = (params) => {
        const query = new URLSearchParams(params).toString();
        fetch(`${baseURL}/main-website/get-landing-data?${query}`)
          .then((res) => res.json())
          .then((result) => {
            dispatch(addUTMData(result));
          });
      };
      useEffect(() => {
        getUTMdata({ page: "UTM" }); 
      }, []);
}

export default useGetUTMData;